var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-grid"},[_vm._t("heading"),(_vm.transition)?[_c('transition-group',{staticClass:"app-grid__listing",class:_vm.className,attrs:{"name":_vm.transition,"tag":"div"}},[_vm._t("default")],2)]:_c('div',{staticClass:"app-grid__listing",class:_vm.className},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }